/* eslint-disable react/prop-types */
import './index.scss';
import ModalBase from '.';
import { ModalProps } from '../../types';
import { useEffect, useState } from 'react';
import { Alert, Button, Input } from '@piggytechng/component-library';
import ModalExecuteAction from './ModalExecuteAction';
import { authPayload } from '../../helpers/utils/auth-payload';
import { OverideButtonStyle, OverideInputStyle } from '../../helpers/utils';
import useTransaction from '../../hooks/useTransaction';

function ModalDeleteTransactionQuick({
  modalIsOpen,
  setIsOpen,
  wallet,
  onSuccess,
}: ModalProps & { wallet: string; onSuccess?: () => void }) {
  const [showActionModal, setShowActionModal] = useState(false);
  const [reference, setReference] = useState('');
  const [reason, setReason] = useState('');
  const { deleteTransaction, isLoading } = useTransaction();

  function closeModal() {
    if (isLoading) return;
    setIsOpen(false);
    setReference('');
    setReason('');
  }

  const proceed = (e: React.FormEvent) => {
    e.preventDefault();

    if (!reference.trim()) {
      Alert.error('Please enter the transaction reference');
      return;
    }

    setShowActionModal(true);
    setIsOpen(false);
  };

  const handleSubmit = async (password: string) => {
    try {
      const payload = {
        ...authPayload(password),
        wallet,
        reference: reference.trim(),
        reason: reason.trim(),
      };

      await deleteTransaction(payload);
      setShowActionModal(false);
      setIsOpen(false);
      setReference('');
      setReason('');
      onSuccess && onSuccess();
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (modalIsOpen) {
      setReference('');
      setReason('');
    }
  }, [modalIsOpen]);

  return (
    <>
      <ModalBase modalIsOpen={modalIsOpen} setIsOpen={setIsOpen}>
        <div className={`modal-processor`}>
          <div className="modal-processor__header">
            <h2>Delete Transaction</h2>
            <button onClick={closeModal}>&times;</button>
          </div>

          <form className="modal-processor__body" onSubmit={proceed}>
            <Input
              {...OverideInputStyle}
              label="Transaction Reference"
              value={reference}
              onChange={(e) => setReference(e.target.value)}
              placeholder="Enter transaction reference"
              required
            />

            <div className="flex--4" style={{ marginBottom: '1rem' }}>
              <label style={{ color: '#666766', marginBottom: '0.5rem', display: 'block' }}>Reason (optional)</label>
              <textarea
                name="reason"
                placeholder="Enter reason for deleting this transaction"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                style={{
                  width: '100%',
                  minHeight: '120px',
                  padding: '1rem',
                  borderRadius: '8px',
                  border: '1px solid #E5E7EB',
                  fontFamily: 'Jakarta',
                  fontSize: '14px',
                  resize: 'vertical',
                }}
              />
            </div>

            <div className="modal-processor__actions">
              <button type="button" onClick={closeModal} className="modal-processor__actions-reject">
                Cancel
              </button>
              <Button {...OverideButtonStyle} className="modal-processor__actions-resolve" type="submit">
                Proceed
              </Button>
            </div>
          </form>
        </div>
      </ModalBase>

      <ModalExecuteAction
        modalIsOpen={showActionModal}
        isLoading={isLoading}
        setIsOpen={setShowActionModal}
        text="delete this transaction?"
        action={(password: string) => handleSubmit(password)}
        actionColor="#1734CA"
        buttonText="Delete"
      />
    </>
  );
}

export default ModalDeleteTransactionQuick;
